<template>
  <v-card flat>
    <v-card-title primary-title>
      <div>
        <div class="subtitle-1 grey--text">Stop ID: {{ activeTransitStop.stopId }}</div>
        <div class="headline" v-if="departures.length > 0">Next Departure: {{ departures[0].departure_text }}</div>
        <div class="grey--text">Current Time: {{ currentTimeString }}</div>
      </div>
    </v-card-title>
    <v-card-text>
      <v-data-table :items="departures" :headers="headers" hide-default-footer>
        <template v-slot:items="props">
          <td><a :href="`https://www.metrotransit.org/imap/map.aspx?route=${props.item.route_id}`">{{ props.item.route_id }}</a></td>
          <td>{{ props.item.description }}</td>
          <td>{{ props.item.departure_text }}</td>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import L from 'leaflet'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { get12HourTime } from '@/utils/utils'

export default {
  name: 'Transit',
  data () {
    return {
      refresher: null,
      refreshInterval: 35000, // Minimum 30 seconds please (http://svc.metrotransit.org/)
      currentTime: new Date(),
      headers: [
        { text: 'Route', value: 'route_id', sortable: false },
        { text: 'Description', value: 'description', sortable: false },
        { text: 'Departure', value: 'departure_text', sortable: false }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'transitStops',
      'activeTransitStop',
      'activeCampus',
      'departures',
      'vehicles'
    ]),
    currentTimeString () {
      return get12HourTime(this.currentTime)
    }
  },
  created () {
    this.onRouteChange()

    if (this.activeTransitStop) {
      this.loadDepartures(this.activeTransitStop.stopId)
    }
  },
  mounted () {
    // Begin updating bus locations
    this.refresher = setInterval(() => {
      if (this.activeTransitStop && this.departures.length) {
        this.loadVehicles(this.departures[0].route_id)
        this.currentTime = new Date()
      }
    }, this.refreshInterval)
  },
  beforeDestroy () {
    clearInterval(this.refresher)
    this.$root.$emit('remove-live-transit')
    this.$root.$emit('focus-campus', this.activeCampus)
  },
  destroyed () {
    this.setActiveTransitStop(null)
    this.setDepartures([])
    this.setVehicles([])
  },
  watch: {
    $route () {
      this.onRouteChange()
    },
    departures () {
      if (this.departures.length) {
        this.loadVehicles(this.departures[0].route_id)
      }
    },
    vehicles () {
      this.updateTransitLayer()
    },
    activeTransitStop () {
      if (this.activeTransitStop) {
        this.loadDepartures(this.activeTransitStop.stopId)
      }
    }
  },
  methods: {
    ...mapMutations([
      'setActiveTransitStop',
      'setDepartures',
      'setVehicles'
    ]),
    ...mapActions([
      'loadDepartures',
      'loadVehicles'
    ]),
    updateTransitLayer () {
      const markers = []
      this.vehicles.forEach(vehicle => {
        if (vehicle.latitude !== 0 && vehicle.longitude !== 0) {
          const marker = L.marker([vehicle.latitude, vehicle.longitude], {
            icon: L.ExtraMarkers.icon({
              icon: 'fa-bus',
              shape: 'circle',
              markerColor: 'red',
              prefix: 'fa'
            })
          })

          markers.push(marker)
        }
      })

      const group = L.featureGroup(markers)

      this.$root.$emit('set-live-transit', group)
    },
    onRouteChange () {
      const transitStops = this.transitStops.filter(transitStop => {
        return transitStop.stopId === this.$route.params.stopId
      })

      if (transitStops.length && (this.activeTransitStop !== transitStops[0])) {
        this.setActiveTransitStop(transitStops[0])
      }
    }
  }
}
</script>
